/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 ***/
// Importing necessary React hooks and Redux utilities
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

// Importing CryptoJS for decrypting data and a secure key from configuration
import cryptoJs from 'crypto-js';
import securekey from '../../../../../config';

// Importing an API action to fetch a single provider's data
import { GetSingleProvider } from '../../../../../reduxToolkit/Providers/providersApi';

// React functional component that manages the logic for document approval/denial
const DocumentTableApp = ({ dataTable, approve }) => {

    // Object to define the document type (approval or not)
    const docType = {
        approve: approve,
    };

    // Initializing Redux dispatch function
    const dispatch = useDispatch();

    // State hooks for modal visibility and selected document details
    const [showModalDeny, setShowModalDeny] = useState(false);
    const [showModalApprove, setShowModalApprove] = useState(false);
    const [documentIdForApprove, setDocumentIdForApprove] = useState(null);
    const [documentIdForDeny, setDocumentIdForDeny] = useState(null);
    const [documentPathForApprove, setDocumentPathForApprove] = useState(null);
    const [documentPathForDeny, setDocumentPathForDeny] = useState(null);

    // Retrieve userId from the first item in dataTable (if exists)
    const [userId, setUserId] = useState(dataTable?.[0]?.userId ?? null);

    // States to store additional user data
    const [userType, setUserType] = useState(null);
    const [fullName, setFullName] = useState(null);
    // Retrieve employee data from session storage
    const employeeData = sessionStorage.getItem('employeeEntryData');

    // Decrypt the stored employee data using AES decryption
    const bytesS = cryptoJs.AES.decrypt(employeeData || '', securekey);

    // Convert decrypted bytes to UTF-8 string
    const userString = bytesS.toString(cryptoJs.enc.Utf8);

    // Parse the decrypted string into a JSON object
    const employee = userString ? JSON.parse(userString) : '';

    // useEffect to fetch user/provider data when userId changes
    useEffect(() => {
        if (!userId) return;

        // Dispatch Redux action to get single provider info by userId
        dispatch(GetSingleProvider(userId)).then(
            ({
                 payload: {
                     data: { data, success },
                 },
             }) => {
                // If the fetch is successful, update userType and fullName
                if (success) {
                    setUserType(data.userType.id);
                    setFullName(data.fullName);
                }
            },
        );
    }, [userId]);

    // Handler to trigger approval modal and set related document info
    const handleApproveDocument = (item) => {
        setShowModalApprove(true);
        setDocumentIdForApprove(item?.id);
        setDocumentPathForApprove(item?.path || item?.companyDocument);
    }

    // Handler to trigger denial modal and set related document info
    const handleDenyDocument = (item) => {
        setShowModalDeny(true);
        setDocumentIdForDeny(item?.id);
        setDocumentPathForDeny(item?.path || item?.companyDocument);
    }

    // Return all relevant states and handler functions to be used in the component
    return {
        docType, userType, employee,
        showModalApprove, setShowModalApprove, documentIdForApprove, documentPathForApprove, fullName,
        showModalDeny, setShowModalDeny, documentIdForDeny, documentPathForDeny,
        handleDenyDocument: (e) => handleDenyDocument(e),
        handleApproveDocument: (e) => handleApproveDocument(e)
    }

}
export default DocumentTableApp;
